"use client";

import { createContext, useContext } from "react";
import type { RelayHistoryProps } from "../types";

/**
 * Carries `<RelayHistory>`'s own configuration (client/recipient/wallet
 * address/callbacks) from the compound root down to `<RelayHistory.Content>`,
 * which is supplied by the host as a child and so can't receive them as
 * props. Mirrors `RelayDepositContext` (`./relay-deposit-provider.ts`) --
 * kept as its own context rather than shared, since `<RelayDeposit>` and
 * `<RelayHistory>` are independent compounds that don't nest inside one
 * another (each owns its own `ResponsiveShell`/`RelayShellContext`).
 */
export const RelayHistoryContext = createContext<RelayHistoryProps | null>(null);

export function useRelayHistoryContext(): RelayHistoryProps {
  const ctx = useContext(RelayHistoryContext);
  if (!ctx) {
    throw new Error(
      "RelayHistory compound components must be used within <RelayHistory>",
    );
  }
  return ctx;
}
